import { getUserEmailAddress } from 'owa-session-store';
/**
 * Util to get published URL for the new personal booking experience.
 */
export default function getNewBookingPublishedUrl(): string {
    let newUrlLink =
        'https://outlook.office.com/findtime/vote?book=' +
        getUserEmailAddress() +
        '&anonymous&ep=signature';
    return newUrlLink;
}
